export default {
  init(payload) {
    if (typeof payload !== 'undefined') {
      return payload;
    }

    return {
      selectedGroup: 'ageTwo'
    };
  },
  /**
   *
   * @param {Object} moduleState
   * @param {String} payload
   * @return {Function} Object.assign()
   */
  updateSelectedGroup(moduleState, payload) {
    return Object.assign({}, moduleState, {selectedGroup: payload});
  }
};



// WEBPACK FOOTER //
// ./home/en-US/js/testimonials-popup/sdo/mutations.js